import tinycolor, { Instance as TinyColor } from 'tinycolor2'
import Button from "@mui/material/Button"
import { memo, useCallback, useMemo } from "react"
import useStyles from './styles'

export type ColorSwatchProps = {
    onClick: (color: TinyColor) => void,
    value: TinyColor,
    selected?: boolean
}


const ColorSwatch: React.FC<ColorSwatchProps> = ({value, selected  = false, onClick}) => {
    const clickHandler = useCallback(() => onClick(value), [onClick, value])
    const { classes, cx } = useStyles()
    return (
        <Button className={cx(classes.root, {[classes.selected]: selected})} onClick={clickHandler} disableElevation disableRipple>
            <div className={classes.inner} style={{ background: value.toRgbString() }} />
        </Button>
    )
}

export default memo(ColorSwatch)